import { render, staticRenderFns } from "./XmlStats.vue?vue&type=template&id=02c33fce&scoped=true&"
import script from "./XmlStats.vue?vue&type=script&lang=js&"
export * from "./XmlStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c33fce",
  null
  
)

export default component.exports